<template>
    <div class="despesas select-modal" >
        <loader v-if="isLoading" />
        <b-table
            :data="despesas"
            class="data-table"
            hoverable
            responsive
            mobile-cards
        >
            <template v-for="(f, i) in fields">
                <b-table-column
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :centered="f.centered || false"
                    v-slot="props"
                >
                    <div class="obs" v-if="f.key == 'obs'">
                        {{ 
                            isNull(props.row.observacaogeral) 
                            ? '---' 
                            : cutString(props.row.observacaogeral, 80) 
                        }}
                    </div>

                    <div v-else-if="f.key == 'data'">
                        {{ props.row.datahorainc | moment("L LT") }}
                    </div>
                    <div v-else-if="f.key == 'codigo'">
                        <strong>
                            <router-link 
                                :to="{
                                    name: 'des-acerto-despesa-item-edit',
                                    params: {iditem: props.row.id},
                                    query: ($route.query && !isNull($route.query.idmotivo)) ? 
                                        {idmotivo:  $route.query.idmotivo} : {}
                                }"
                            >
                            {{ props.row.iddes_acerto_despesa_itemerp }}
                            </router-link>
                        </strong>
                    </div>

                    <div v-else-if="f.key == 'valor'">
                        <router-link 
                            :to="{
                                name: 'des-acerto-despesa-item-edit',
                                params: {iditem: props.row.id},
                                query: ($route.query && !isNull($route.query.idmotivo)) ? 
                                        {idmotivo:  $route.query.idmotivo} : {}
                            }"
                        >
                            {{ props.row.valordespesa | decimal(null, true) }}
                        </router-link>
                    </div>

                    <div v-else-if="f.key == 'situacao'">
                        <b-tag 
                            class="table-tag table-tag-full-width"
                            :type="isStatusButtonType(props.row)"
                            size="is-medium"
                        >
                            <span v-if="props.row[f.key] == 0">
                                {{ $t('reprovado') }}
                            </span>
                            <span v-else-if="props.row[f.key] == 1">
                                {{ $t('aprovado') }}
                            </span>
                            <span v-else-if="props.row[f.key] == 3 && acertoDespesa.situacao == 3">
                                {{ $t('em-criacao') }}
                            </span>
                            <span v-else-if="props.row[f.key] == 3 && acertoDespesa.situacao == 4">
                                {{ $t('aguardando-aprovacao') }}
                            </span>
                            <span 
                                v-else-if="
                                    props.row[f.key] == 3 && 
                                    acertoDespesa.situacao == 5 && 
                                    acertoDespesa.datahoraalt > props.row['datahorainc']
                                "
                            >
                                {{ $t('aguardando-aprovacao') }}
                            </span>
                            <span 
                                v-else-if="
                                    props.row[f.key] == 3 && 
                                    acertoDespesa.situacao == 5 && 
                                    acertoDespesa.datahoraalt < props.row['datahorainc']
                                "
                            >
                                {{ $t('em-criacao') }}
                            </span>
                            
                        </b-tag>
                    </div>

                    <!-- Componente para abrir modal de fotos -->
                    <div v-else-if="f.key == 'fotos'" >
                        <span
                            v-if="props.row.qntfotos > 0"
                            @click="openModalFotos(props.row.uuid)"
                            class="clickable" 
                        >
                            <b-icon 
                                class="has-badge-primary mt-1" 
                                icon="camera"
                                :data-badge="props.row.qntfotos"
                                v-tippy 
                                :title="$t('msg-tooltip-despesa-n-fotos', { n: props.row.qntfotos })"
                            /> 
                        </span>
                        <span v-else>---</span>
                    </div>

                    <div v-else-if="f.key == 'acoes'">
                        <!-- Motivo reprovação -->
                        <span 
                            @click="motivoReprovacao(props.row)"
                            v-if="
                                props.row.situacao == 0 && 
                                props.row.idmotivoregistro != 0 && 
                                props.row.idmotivoregistro != null
                            "
                        >
                            <b-icon
                                class="is-clickable"
                                icon="comment-remove"
                                type="is-primary"
                                size="is-medium"
                                v-tippy 
                                :title="$t('desaprovado-por-n', { n: props.row.nomeusuariovalidacao })"
                            />
                        </span>
                        <span v-else-if="props.row.situacao == 0">---</span>
                        <!-- Sem ação -->
                        <span v-if="props.row.situacao == 1">---</span>
                        <!-- Reprovar -->
                        <b-button
                            v-if="
                                props.row.situacao == 3 && 
                                acertoDespesa.situacao == 4 && 
                                isSupervisor
                            "
                            class="action-button"
                            type="is-danger"
                            icon-right="close"
                            @click="promptReproveItem(props.row)"
                            v-tippy 
                            :title="$t('reprovar')"
                        />
                        <span 
                            v-else-if="props.row.situacao == 3 && acertoDespesa.situacao == 4"
                        >---</span>
                        <!-- Excluir -->
                        <b-button
                            v-if="
                                (props.row.situacao == 3 && 
                                acertoDespesa.situacao == 3 && 
                                !cantEdit) ||
                                (props.row.situacao == 3 && 
                                acertoDespesa.situacao == 5 && 
                                acertoDespesa.datahoraalt < props.row['datahorainc'])
                            "
                            class="action-button"
                            type="is-danger"
                            icon-right="delete"
                            @click="promptDeleteItem(props.row)"
                            v-tippy 
                            :title="$t('excluir')"
                        />
                    </div>

                </b-table-column>
            </template>
            <template slot="bottom-left">
                <div class="columns despesa-footer">
                    <th id="footer-1" class="column is-12">
                        {{ $t('registro') }}: {{ despesas.length }} 
                    </th>
                    <th id="footer-2" class="column is-12">
                        {{ $t('valor') }} 
                        {{ (valorTotalDespesasDaPagina)  | decimal(null, true) }} 
                </th>
                </div>
            </template>
        </b-table>

        <!-- Modal fotos da despesa -->
        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="carousels = [], isShowModalFotos = false"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel
                                :pause-info="false"
                                :animated="'fade'"
                                :progress="true"
                            >
                                <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                                    <section 
                                        :class="`hero is-medium is-${carousel.color}`" 
                                    >
                                        <div
                                            class="hero-body-img has-text-centered"
                                            :style="{
                                                backgroundImage: 'url(' + carousel.url + ')',
                                                backgroundSize: 'contain',
                                                backgroundPosition: 'center center',
                                                backgroundRepeat: 'no-repeat',
                                                height: '200px',
                                                cursor: 'zoom-in'
                                            }"
                                            @click="() => toggleZoom(carousel.url)">
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal fotos da despesa -->
        <b-modal
            :active.sync="isShowModalReprove"
            @close="isShowModalReprove = false"
        >
            <div class="bg">
                <ModalMotivo
                    v-if="isShowModalReprove"
                    :id="toReprove != null ? toReprove.id : 0"
                    :idmotivoregistro="toReprove != null ? toReprove.idmotivoregistro : 0"
                    :descricao="this.motivodespesa.descricao"
                    origem="DESPESA_INATIVA"
                    @fecharModal="isShowModalReprove = false"
                    @save="reprove($event)"
                    @redirectMotivoReprovacao="redirectMotivoReprovacao"
                />
            </div>
        </b-modal>
    </div>
</template>
<script>
import AcertoDespesaItemService from "@/services/despesas/AcertoDespesaItemService";
import ModalMotivo from "@/components/despesas/acerto-despesa//modal/ModalMotivo.vue";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
        ModalMotivo,
    },
    props: {
        motivodespesa: {
            type: Object,
            default: () => {},
        },
        despesas: {
            type: Array,
            default: () => [],
        },
        cantEdit: {
            type: Boolean,
            default: true,
        },
        isSupervisor: {
            type: Boolean,
            default: true,
        },
        acertoDespesa: null,
    },
    data() {
        return {
            carousels: [],
            fields: [
                { key: "codigo", width: null, sortable: false },
                { key: "valor", width: null, sortable: false },
                { key: "data", width: null, sortable: false },
                { key: "obs", width: null, sortable: false },
                { key: "fotos", width: 50, sortable: false },
                { 
                    key: "acoes", 
                    width: 60, 
                    sortable: false, 
                    centered: true 
                },
                { 
                    key: "situacao", 
                    width: this.acertoDespesa.situacao == 4 ? 225 : 160, 
                    sortable: false, 
                    centered: true 
                },
            ],
            service: new AcertoDespesaItemService(this.$http, this.$router),
            valorTotalDespesasDaPagina: 0,
            isLoading: false,
            totalAcerto: 0,
            fotosDespesa : [],
            isShowModalFotos: false,
            isShowModalReprove: false,
            toReprove: null,
            
        };
    },
    created() {
        //sync despesas selecionadas do componente pai para os filhos mudado para user keep-alive
        this.despesasSelecionadas = this.propDespesasSelecionadas

        this.somarvalorTotalDespesasDaPagina();
    },
    watch:{
        despesas: {
            deep: true,
            handler(){
                this.somarvalorTotalDespesasDaPagina()
            }
        }
    },
    methods: {
        toggleZoom(imag) {
            const h = this.$createElement
            
            const vnode = h('p', { class: "image" }, [
                h('img', { attrs: { src: imag }})
            ])
            
            this.$buefy.modal.open({
                content: [ vnode ]
            })
        },
        somarvalorTotalDespesasDaPagina() {
            this.valorTotalDespesasDaPagina = 0;
            this.despesas.forEach((despesa) => {
                this.valorTotalDespesasDaPagina += despesa.valordespesa;
            });
        },
        openModalFotos(uuid){
            this.service
                .findAllFotosDespesasByDespesa(uuid)
                .then((r) => {
                    this.fotosDespesa = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar os fotos: " + e);
                })
                .finally(_ => {
                    this.fotosDespesa.forEach((foto) => {
                        this.carousels.push({
                            url: foto.caminho,
                            nome: foto.nome,
                        });
                    });
                    this.isShowModalFotos = true;
                })
        },
        isStatusButtonType(item) {
            if (item.situacao == 0) {
                return "is-danger"; 
            } else if (item.situacao == 1) {
                return "is-success";
            } else if (item.situacao == 3 && this.acertoDespesa.situacao == 3) {
                return "is-primary";
            } else if (item.situacao == 3 && this.acertoDespesa.situacao == 4) {
                return "is-warning";
            } else if (
                item.situacao == 3 && 
                this.acertoDespesa.situacao == 5 && 
                this.acertoDespesa.datahoraalt > item.datahorainc
            ) {
                return "is-warning";
            } else if (
                item.situacao == 3 && 
                this.acertoDespesa.situacao == 5 && 
                this.acertoDespesa.datahoraalt < item.datahorainc
            ) {
                return "is-primary";
            }
        },
        promptDeleteItem(row) {
            this.$root.confirm({
                message: this.$t('msg-confirma-remover-n', 
                    { n: this.motivodespesa.descricao + 
                        ' - ' + 
                        this.getDecimal(row.valordespesa, null, true) 
                    }
                ),
                onConfirm: (_) => this.remove(row),
            });
        },
        remove(row) {
            this.isLoading = true;
            
            let despesa = this.motivodespesa.descricao + ' - ' + 
                this.getDecimal(row.valordespesa, null, true);
            

            this.service
                .remove(row.uuid)
                .then((r) => {
                    let msg = this.$t('msg-sucesso-remover-n', { n: despesa });

                    this.$root.showMessage('success', msg, true, false);
                    this.$emit('reload', this.motivodespesa.id)
                })
                .catch((e) => {
                    let msg = this.$t('msg-erro-remover-n', { n: despesa });

                    this.$root.showMessage('error', msg, true, false);
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },

        motivoReprovacao(row) {
            this.toReprove = row;
            this.isShowModalReprove = true;
        },
        promptReproveItem(row) {
            this.toReprove = null;
            this.$root.confirm({
                message: this.$t('msg-confirma-reprovar-n', 
                    { n: this.motivodespesa.descricao + 
                        ' - ' + 
                        this.getDecimal(row.valordespesa, null, true) 
                    }
                ),
                onConfirm: _ => this.getById(row.id),
            });
        },
        reprove(idmotivoregistro) {
            this.isSaving = true;
            
            let despesa = this.motivodespesa.descricao + ' - ' + 
                this.getDecimal(this.toReprove.valordespesa, null, true);

            this.toReprove.idusuariovalidacao = this.$store.state.user.usuario.id;
            this.toReprove.nomeusuariovalidacao = this.$store.state.user.usuario.nome;
            this.toReprove.idmotivoregistro = idmotivoregistro;
            this.toReprove.situacao = 0;

            this.service
                .save(this.toReprove)
                .then((r) => {
                    let msg = this.$t('msg-sucesso-reprovar-n', { n: despesa });

                    this.$root.showMessage('success', msg, true, false);
                    this.$emit('reload', this.motivodespesa.id)
                })
                .catch((e) => {
                    let msg = this.$t('msg-erro-reprovar-n', { n: despesa });

                    this.$root.showMessage('error', msg, true, false);
                })
                .finally(_ => {
                    this.isSaving = false;
                });
        },
        getById(iditem) {
            this.isLoading = true;

            this.service
                .find(iditem)
                .then(data => {
                    if(data.content) {
                        this.toReprove = data.content;
                        this.isShowModalReprove = true;
                    }else{
                        this.toReprove = null;
                    }
                })
                .catch(e => {
                    this.toReprove = null;
                    this.$root.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(_ => { 
                    this.isLoading = false; 
                })
        },
        redirectMotivoReprovacao() {
            this.$emit("redirectMotivoReprovacao", true);
        }
    },
};
</script>

<style scoped>
.hero-body-img{
    margin-top: 10px;
    padding: 20px;
}
</style>